// accordion
import $ from "jquery";

$(function(){
	var qBox   = $('.faq-q-box');
	var qTextG = $('.faq-q-text');
	var aTextG = $('.faq-a-text');
	var aTextHeights = [];

	qBox.each(function(i){
		var _this      = $(this);
		var qText      = _this.find('.faq-q-text');
		var aText      = _this.find('.faq-a-text');
		var aTextH     = 1.2*aText.height();
		var closeClass = 'q-close';
		var openClass  = 'q-open';
		var duration   = 300;
		aTextHeights.push(aTextH);

		function accordionAnime(target, h){
			var d = new $.Deferred;
			target.animate({'height': h}, 300, 'swing', function(){d.resolve()});
			return d.promise();
		}
		function addAccordionClass(target, rClass, aClass){
			var d = new $.Deferred;
			setTimeout(function(){
				target.removeClass(rClass).addClass(aClass);
				d.resolve();
			}, 0);
			return d.promise();
		}

		qText.addClass(closeClass);
		aText.css({'overflow': 'hidden', 'height': 0});

		qText.click(function(){
			if($(this).hasClass(closeClass)){
				accordionAnime(aTextG, 0)
				.then(addAccordionClass(qTextG, openClass, closeClass))
				.then(accordionAnime(aText, aTextH))
				.then(addAccordionClass(qText, closeClass, openClass));
			}else{
				accordionAnime(aText, 0)
				.then(addAccordionClass(qText, openClass, closeClass));
			}
		});
	});

	$("a[href ^= '#faq']").click(function() {
		var speed = 400;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 109;
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

	var faqId = window.location.hash;
	if (faqId) {
		var result = faqId.match(/\d+/);
		var faqNum = parseInt(result[0], 10);
		if (!faqNum) return;

		if ($(faqId).prop('tagName') == 'DT') {
			$(faqId).toggleClass("active");
			$(faqId).next().slideToggle();
		} else {
			$(faqId).find('.faq-q-text').removeClass('q-close').addClass('q-open');
			var aText = $(faqId).find('.faq-a-text');
			aText.css({'height': aTextHeights[faqNum - 1]});
		}
	}
});

// SP用
$(function(){
  $(".faq-cont-inner dt").on("click", function(){
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });
  $("a[href ^= '#faq']").click(function() {
    var speed = 400; // ミリ秒
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 52;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});
